import Vue from "vue";
import Vuex from "vuex";
import { createMapper, registerModule } from "vuex-smart-module";
import Store from "@/store/Store";
import { OperatersApi } from "@/types";
import OperatersBarWrapper from "@/components/OperatersBarWrapper.vue"

Vue.use(Vuex);
Vue.config.productionTip = false;
Vue.config.devtools = true;

window.z = window.z || {};
if (window.z.rootStore === undefined) {
  window.z.rootStore = new Vuex.Store({
    strict: process.env.NODE_ENV !== "production"
  });
}

const rootStore = window.z.rootStore;
registerModule(rootStore, ["OperatersStore"], "OperatersStore/", Store);
const store = Store.context(rootStore);
const storeMapper = createMapper(Store);

const api: OperatersApi = {

  initialize( endpoint: string ) {
    store.actions.initialize( endpoint );

    new Vue({
      components: { OperatersBarWrapper },
      template: "<operaters-bar-wrapper :data='data'></operaters-bar-wrapper>",
      el: "#vue-operaters-sidebar",
      store: rootStore,
      computed: {
        ...storeMapper.mapState(["data"])
      }
    });
  },

  load( args : any ) {
    store.actions.load( args );
  },

  clear() {
    store.actions.clear();
  }
}

export default api;